import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import SVG from "react-inlinesvg";
import { faChevronRight, faUser, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { linkgroup } from "./JoinGroupV2";
import { Tooltip } from "antd";

function UserHome() {
    const { isLogined, userInfo } = useSelector((state) => state.auth);
    return (
        <div>
            <div className="bg-gradient-to-br from-[#fad126] to-[#ff544f] to-75% w-full aspect-profile overflow-hidden relative">
                <img src="img/ui/bg_wave.png" alt="bgwave" className=" top-0 w-full h-full object-cover z-10" />
                {isLogined && (
                    <div className="absolute z-30 w-full h-full top-0 flex items-center">
                        <div className="relative w-3/12 h-2/3 flex items-center justify-center flex-col gap-1">
                            <Tooltip title="Nhấn để xem trang cá nhân" placement="top">
                                <div className="h-4/5 aspect-square relative flex items-center justify-center group">
                                    <div className="absolute inset-0 rounded-full bg-yellow-300 opacity-50 blur-xl group-hover:opacity-70 group-hover:blur-2xl transition-all duration-300"></div>
                                    <Link to={"/user-info"} className="h-full w-full rounded-full bg-surface border-4 border-yellow-300 overflow-hidden relative hover:border-yellow-200 transition-all duration-300 z-10" style={{ boxShadow: "0 0 15px rgba(253, 224, 71, 0.7), 0 0 25px rgba(253, 224, 71, 0.5), 0 0 35px rgba(253, 224, 71, 0.3)" }}>
                                        {userInfo.avatar && <img className="object-cover h-full w-full" src={`${process.env.REACT_APP_API_PUBLIC_URL}/img/users/${userInfo.avatar}`} alt="user-avatar" />}
                                        {!userInfo.avatar && (
                                            <span className="flex justify-center items-center bg-primary-200 w-full h-full">
                                                <FontAwesomeIcon icon={faUser} />
                                            </span>
                                        )}
                                        <div className="absolute bottom-0 right-0 bg-blue-500 rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            <FontAwesomeIcon icon={faUserCircle} className="text-white text-xs" />
                                        </div>
                                    </Link>
                                </div>
                            </Tooltip>
                            <Link to={"/user-info"} className="w-3/4 h-5 md:h-6 relative flex justify-between items-center bg-transparent bg-gradient-to-r from-transparent from-5% via-amber-200 to-amber-500 rounded-2xl transition-colors duration-200 cursor-pointer">
                                <div className="relative h-full aspect-square">
                                    <FontAwesomeIcon icon={faUserCircle} className="text-yellow-300 text-shadow-sm text-xl md:text-2xl absolute bottom-0" />
                                </div>
                                <span className="text-[10px] md:text-base whitespace-nowrap">Trang cá nhân</span>
                                <FontAwesomeIcon icon={faChevronRight} className="pr-1 text-xs" />
                            </Link>
                        </div>
                        <div className="text-white w-9/12 flex flex-col gap-1 md:gap-4">
                            <div className="flex gap-2 items-center">
                                <span>Số dư khả dụng</span>
                                <Tooltip title="Số dư khả dụng là số tiền hiện có thể rút (đã trừ các lệnh rút đang chờ xử lý). Hoa hồng đơn chờ duyệt chưa được tính vào đây — xem mục Chờ duyệt bên dưới.">
                                    <FontAwesomeIcon icon={faQuestionCircle} className="text-sm" />
                                </Tooltip>
                            </div>
                            {/* Đã đăng nhập: bấm vào số dư mở sổ biến động (giải thích tiền ở đâu ra) */}
                            {isLogined ? (
                                <Link to="/user-info/cash-history" title="Xem lịch sử số dư" className="flex gap-1 items-end w-fit">
                                    <span className="text-3xl md:text-5xl font-lexend font-semibold">{parseFloat(userInfo.cash || 0).toLocaleString("vi-VN")}</span>
                                    <span>VNĐ</span>
                                    <FontAwesomeIcon icon={faChevronRight} className="text-xs mb-1.5 opacity-80" />
                                </Link>
                            ) : (
                                <div className="flex gap-1 items-end">
                                    <span className="text-3xl md:text-5xl font-lexend font-semibold">Cần LOGIN!</span>
                                    <span>VNĐ</span>
                                </div>
                            )}
                            {isLogined && (userInfo.pendingCash || 0) > 0 && (
                                <div className="text-xs md:text-sm text-white/80 -mt-1">
                                    Chờ duyệt: {parseFloat(userInfo.pendingCash || 0).toLocaleString("vi-VN")} VNĐ
                                </div>
                            )}
                            <div className="grid grid-cols-8 w-full gap-1 pr-2">
                                <Link to={"user-info/withdraw"} className="col-span-3 bg-[#6585f2] rounded-md overflow-hidden relative">
                                    <img className="w-full h-full object-cover translate-y-1" src="img/ui/cashback_wave.png" alt="cashback" />
                                    <div className="absolute w-full h-full top-0  grid grid-cols-8 items-center justify-between px-1">
                                        <div className="p-1 w-full h-full col-span-2 flex justify-center items-center">
                                            {/* Giữ bg-white CỐ Ý: vòng tròn này lót cho icon TÔ ĐEN nằm trên ô màu
                                                xanh/tím. Dùng token bề mặt thì ở chế độ tối thành icon đen trên nền đen. */}
                                            <div className="w-full col-span-2 aspect-square rounded-full bg-white p-1 overflow-hidden">
                                                <SVG src="img/ui/coin.svg" fill="black" width={"auto"} height={"auto"} />
                                            </div>
                                        </div>
                                        <span className="text-xs text-center whitespace-nowrap md:text-xl col-span-5">Rút tiền</span>
                                        <FontAwesomeIcon icon={faChevronRight} className="text-xs col-span-1" />
                                    </div>
                                </Link>
                                <Link to={"/user-info/order"} className="col-span-3 bg-[#b790fd] rounded-md overflow-hidden relative">
                                    <img className="w-full h-full object-cover translate-y-1" src="img/ui/order_wave.png" alt="order" />
                                    <div className="absolute w-full h-full top-0  grid grid-cols-8 items-center justify-between px-1">
                                        <div className="p-1 w-full h-full col-span-2 flex justify-center items-center">
                                            {/* Giữ bg-white CỐ Ý: vòng tròn này lót cho icon TÔ ĐEN nằm trên ô màu
                                                xanh/tím. Dùng token bề mặt thì ở chế độ tối thành icon đen trên nền đen. */}
                                            <div className="w-full col-span-2 aspect-square rounded-full bg-white p-1 overflow-hidden">
                                                <SVG src="img/ui/cart.svg" fill="black" width={"auto"} height={"auto"} />
                                            </div>
                                        </div>
                                        <span className="text-xs text-center whitespace-nowrap md:text-xl col-span-5">Đơn hàng</span>
                                        <FontAwesomeIcon icon={faChevronRight} className="text-xs col-span-1" />
                                    </div>
                                </Link>
                                <Link to={linkgroup.zaloLonghousee} target="_blank" className="col-span-2 flex justify-center items-center gap-1 p-1 py-2 rounded-md text-sm bg-gray-500">
                                    <span>
                                        <FontAwesomeIcon icon={faQuestionCircle} />
                                    </span>
                                    <span className="text-xs md:text-xl">Trợ giúp</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
                {!isLogined && (
                    <div className="absolute z-30 w-full h-full top-0 flex justify-center items-center font-lexend text-xl text-center">
                        <div className="h-full p-4">
                            <img src="img/ui/longiconhi.svg" alt="longicon" className="h-full object-cover" />
                        </div>
                        <div className="p-2">
                            <div>
                                <span className="font-bold text-white">SĂN SALE CỰC ĐỈNH</span>
                                <p className="text-white font-semibold">HOÀN TIỀN CỰC ĐÃ</p>
                            </div>
                            <div className="mt-2">
                                <Link to={"/login"} className="px-4 py-2 text-base bg-slate-600 text-white rounded-lg">
                                    BẮT ĐẦU NGAY ❤️
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default UserHome;
